import { scrollToAnchor } from '@cian/newbuilding-utils';

import { STICKY_HEADER_HEIGHT } from '../../../../constants/elements';

import { trackStickyHeaderTabClick } from './trackStickyHeaderTabClick';

export function onNavigationLinkClick(slug: string): void {
  trackStickyHeaderTabClick(slug);

  const anchor = `#${slug}`;

  scrollToAnchor({ anchor, hasRelocation: false, offset: STICKY_HEADER_HEIGHT })(event);
}
